/**
 * Card utility functions for card type detection and validation
 */

/**
 * Determine if card is Visa or Mastercard based on card number
 * @param {string|number} cardNumber - The card number to analyze
 * @returns {string} 'visa', 'mastercard', or 'mastercard' as default
 */
export const getCardType = (cardNumber) => {
  if (!cardNumber) return 'mastercard'; // default
  
  const cardStr = cardNumber.toString();
  const firstDigit = cardStr.charAt(0);
  const firstTwo = cardStr.substring(0, 2);
  const firstFour = cardStr.substring(0, 4);
  
  // Visa: starts with 4
  if (firstDigit === '4') {
    return 'visa';
  }
  
  // Mastercard: starts with 51-55 or 2221-2720
  if ((firstTwo >= '51' && firstTwo <= '55') || (firstFour >= '2221' && firstFour <= '2720')) {
    return 'mastercard';
  }
  
  return 'mastercard'; // default
};
